module.exports = __webpack_public_path__ + "static/media/32-8.189bb933.mp3";